import QweNotification from "../QweNotify/QweNotify"

export default {
    computed:{
        asyncNotificationCounter:function(){ 
            return this.$store.state.asyncNotificationCounter;
        }
    },
    watch:{
        "asyncNotificationCounter":function(newValue, oldValue){  
            let notification = this.$store.state.notificationMessage;
            let notificationOptions = {
                title:notification.summary,
                message:(notification.isHtmlPreferred ? notification.htmlBody : notification.textBody),
                dangerouslyUseHTMLString:notification.isHtmlPreferred, 
            };
            if(!notification.autoClose){
                notificationOptions.duration = 0;
            }
            QweNotification[notification.notificationState](notificationOptions);
        }
    }
}